<div class="component-container">

  <div class="component-header">
    <div class="component-header-underline">
      <div class="component-header-text">
        {{ errorName | gallixCamelCaseToSeparated }}
      </div>
    </div>
  </div>

  <div class="component-content">
    <app-shared-accordion>

      <app-shared-accordion-item
        (accordionHeaderClicked)="isMessageAccordionOpened"
        [isOpen]="isMessageAccordionOpened">
        <div class="header">Message</div>
        <div class="body">
          <div class="item">
            <div class="error-message">
              {{ errorMessage }}
            </div>
          </div>
        </div>
      </app-shared-accordion-item>

      <app-shared-accordion-item
        (accordionHeaderClicked)="isPayloadAccordionOpened"
        [isOpen]="isPayloadAccordionOpened">
        <div class="header">Payload</div>
        <div class="body">
          @for (
            item of errorActionParsedArray; track trackByItemProperty($index,
            item)) {
            <div class="item">
              <div>{{ item.key | gallixCamelCaseToSeparated }}</div>
              <span></span>
              <div>{{ item.value }}</div>
            </div>
          }
        </div>
      </app-shared-accordion-item>

    </app-shared-accordion>
  </div>

</div>
